import { useState } from 'react';
import BookDemoModal from './BookDemoModal';

export default function CTASection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section id="book-demo" className="bg-[#060A14] py-28 md:py-36 relative overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5aede51408214f34693ca3fe22e45a12.jpg"
            alt="Scale your business"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#060A14]/60 via-[#060A14]/50 to-[#060A14]"></div>
        </div>

        {/* Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#2563EB]/12 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
          <p className="text-[#F97316] text-xs font-semibold tracking-[0.2em] uppercase mb-6 font-inter">Get Started</p>

          <h2 className="text-6xl md:text-7xl font-black text-white leading-[1.0] tracking-tight mb-6 font-poppins">
            Turn Every Lead<br />Into Revenue
          </h2>
          <p className="text-white/45 text-xl mb-12 max-w-xl mx-auto font-inter font-light">
            Install the system that works 24/7 for your business. No missed calls. No lost jobs. Just growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => setModalOpen(true)}
              className="group bg-white text-[#0F172A] font-semibold text-base px-10 py-4 rounded-full hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap font-inter flex items-center gap-2.5"
            >
              Schedule Your Strategy Call
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform duration-200"></i>
            </button>
          </div>

          <p className="text-white/20 text-xs mt-8 font-inter">Free consultation. No commitment required.</p>

          {/* Trust indicators */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8">
            {[
              { icon: 'ri-shield-check-line', label: 'No contracts required' },
              { icon: 'ri-customer-service-2-line', label: 'Dedicated support' },
              { icon: 'ri-rocket-line', label: 'Live in 7 days' },
            ].map((t) => (
              <div key={t.label} className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${t.icon} text-white/25 text-base`}></i>
                </div>
                <span className="text-white/30 text-sm font-inter">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <BookDemoModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
